import { useState } from 'react';
import type { Card } from '../../shared/doc.js';
import { addTodoItem, removeTodoItem, setTodoItem, updateCard } from '../../shared/ops.js';
import type { ProjectConn } from '../doc/useProject.js';

export function TodoCard({ conn, card, editing }: { conn: ProjectConn; card: Extract<Card, { kind: 'todo' }>; editing: boolean }) {
  const [draft, setDraft] = useState('');
  const stop = (e: React.PointerEvent) => e.stopPropagation();
  return (
    <div className="todo">
      {editing ? (
        <input className="todo-title" aria-label="List title" value={card.title} placeholder="List title" onPointerDown={stop} onChange={(e) => updateCard(conn.doc, conn.me, card.id, { title: e.target.value.slice(0, 200) })} />
      ) : (
        card.title && <strong>{card.title}</strong>
      )}
      <ul>
        {card.items.map((item) => (
          <li key={item.id} className={item.done ? 'done' : ''}>
            <label onPointerDown={stop}>
              <input type="checkbox" checked={item.done} onChange={(e) => setTodoItem(conn.doc, conn.me, card.id, item.id, { done: e.target.checked })} />
              {item.text}
            </label>
            {editing && (
              <button className="link small" aria-label={`Remove ${item.text}`} onPointerDown={stop} onClick={() => removeTodoItem(conn.doc, card.id, item.id)}>
                ×
              </button>
            )}
          </li>
        ))}
      </ul>
      {editing && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (draft.trim()) addTodoItem(conn.doc, conn.me, card.id, draft.trim());
            setDraft('');
          }}
        >
          <input aria-label="New item" placeholder="Add an item" value={draft} onPointerDown={stop} onChange={(e) => setDraft(e.target.value)} autoFocus />
        </form>
      )}
    </div>
  );
}
